import { useMemo } from "react";
import {
  VacancyApplicant,
  VacancyApplicantEmploymentStatusLevel,
  VacancyApplication,
} from "../../../model/VacancyApplicant.interface";
import BFIndicatorOverlay from "@/modules/abstract-ui/general/IndicatorOverlay/BFIndicatorOverlay";
import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import VacancyApplicantEmployerPart from "../vacancy-applicant-entry/VacancyApplicantEmployerPart";
import { ActivityApplicationConstants } from "@/apps/tatar/activityApp/ActivityHooks";
import VacancyOfferUtils from "../../utils/VacancyOfferUtils";

type Props = {
  application: VacancyApplication;
  applicant: VacancyApplicant;
  activity: APActivity;
  constants: ActivityApplicationConstants;
  onOpenGuarantorModal?: () => void;
};

const VacancyApplicantEmploymentStatus = (props: Props) => {
  const { application, applicant, activity, constants, onOpenGuarantorModal } =
    props;

  const renderSpeaker = (
    level: VacancyApplicantEmploymentStatusLevel,
    close: () => void
  ) => {
    return (
      <div className="padding-20">
        <VacancyApplicantEmployerPart
          applicant={applicant}
          application={application}
          activity={activity}
          constants={constants}
          level={level}
          onOpenGuarantorModal={() => {
            if (onOpenGuarantorModal) {
              close();
              onOpenGuarantorModal();
            }
          }}
        />
      </div>
    );
  };

  const level: VacancyApplicantEmploymentStatusLevel = useMemo(() => {
    return VacancyOfferUtils.getEmploymentStatusLevel(applicant, activity);
  }, [applicant, activity]);

  return (
    <BFIndicatorOverlay
      identifier="vacancy-applicant-employment-status"
      placement="left"
      speakerFC={(close: () => void) => {
        return renderSpeaker(level, close);
      }}
      level={level?.level || "warn"}
    />
  );
};

export default VacancyApplicantEmploymentStatus;
